export const api = {
  getSyncList: '/cms/syncdata/querySyncDataList.json', // 获取同步列表
  areaList: '/cms/account/queryAssociationalDeviceTree.json', // 获取区域
  getGateTree: '/bms/device/queryDeviceTree.json', //出入口授权-人员通行权限，查询人脸闸机设备树
  reloadSyncData: '/cms/syncdata/reloadSyncData.json', //人脸/车辆授权定时任务同步授权
  queryVisitorApplyDetail: '/vas/appointment/queryAppointmentDetail.json', //我的预约详情查询接口
  queryAppointmentWorkflow: '/vas/appointment/queryAppointmentWorkflow.json',
  
}